export default __webpack_public_path__ + "static/media/neonArtboard 1@4x.bd35784e.png";